import {generatePackingList} from './generate-packing-list'
import {getPackingListGeneratorItems} from './get-items'

export const packingListApi = {
  getItems: getPackingListGeneratorItems,
  generatePackingList,
}
